import { z } from 'zod';
import { LOGGING_LEVEL } from '#schemas/config-override/helpers/enums.ts';

export const loggingLevelSchema = z.enum([...LOGGING_LEVEL, '']);

export const loggingLevelRequiredSchema = loggingLevelSchema.refine((val) => val !== '', {
  message: 'Choose a logging level',
});

export const loggingLevelStrictSchema = z.enum(LOGGING_LEVEL);
